import { connect } from 'react-redux'
import Component from './component'
import { confirmChangeEmail } from '../../../../store/actions'

export default connect(null, { confirmChangeEmail })(Component as any)
